import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'rentware-spacer',
    styleUrl: 'style.sass',
    shadow: true,
})

export class RentwareSpacer {
    @Prop() size: "S" | "M" | "L" | "XL";

    get spacerClass(): string {
        return "Spacer " + this.size;
    }

    render() {
        return (
            <div class={this.spacerClass} />
        )
    }
}
